var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{attrs:{"active-class":"primary--text","to":_vm.link.to,"two-line":""}},[_vm._v(" "+_vm._s(_vm.link.title)+" "),_c('v-spacer'),_c('v-icon',{attrs:{"right":""}},[_vm._v(_vm._s(_vm.link.icon))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }